export const RESULT_REDIRECT_DIRECTLY = `redirecting directly, don't hide the loader`;
export const RESULT_HIDE_LOADER = `hide the loader`;
